import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PageCode} from "humanresources-common-shared";
import {UntypedFormGroup, Validators } from "@angular/forms";

@Component({
        selector: 'position-picker-search-form',
    templateUrl: './position-picker-search-form.component.html',
})
export class PositionPickerSearchFormComponent implements OnInit {
    @Input() pageCode = PageCode.PERSONNEL_PICKER;
    @Input() form;
    @Output() valueEvent = new EventEmitter<any>();
    @Input() isClear: boolean;
    @Input() showDate: boolean;
    @Output() onBack = new EventEmitter();
    @Output() onSearch = new EventEmitter();
    constructor() {}

    ngOnInit(): void {
        if(this.showDate)  {
            this.form.get('date').addValidators(Validators.required);
        }
    }
}
